import React from 'react';
import ReactDOM from 'react-dom';

export const iconWrapper = (group, title, iconSize = 24) => {
    return (
        <span className="bp3-icon">
            <svg
                className="custom-icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width={iconSize}
                height={iconSize}
                viewBox="0 0 48 48"
            >
                {title && <desc>{title}</desc>}
                {group}
            </svg>
        </span>
    );
};

const GROUP = iconWrapper(
    <g>
        <path d="M19.41467,14.18182a.9391.9391,0,0,1,.42.09914l6.14888,3.07444a.93911.93911,0,0,0,.42.09915h8.65737A.93912.93912,0,0,1,36,18.39367V32.87906a.93912.93912,0,0,1-.93912.93912H12.93912A.93912.93912,0,0,1,12,32.87906V15.12094a.93912.93912,0,0,1,.93912-.93912h6.47555m0-2H12.93912A2.94244,2.94244,0,0,0,10,15.12094V32.87906a2.94244,2.94244,0,0,0,2.93912,2.93912H35.06088A2.94244,2.94244,0,0,0,38,32.87906V18.39367a2.94244,2.94244,0,0,0-2.93912-2.93912H26.654l-5.92488-2.96244a2.9541,2.9541,0,0,0-1.31441-.31029Z" />
    </g>,
    'group'
);
const REPEAT = iconWrapper(
    <g>
        <path d="M20.45454,11v9.45454H11V11h9.45454m0-2H11a2,2,0,0,0-2,2v9.45454a2,2,0,0,0,2,2h9.45454a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2Z" />
        <path d="M37,11v9.45454H27.54546V11H37m0-2H27.54546a2,2,0,0,0-2,2v9.45454a2,2,0,0,0,2,2H37a2,2,0,0,0,2-2V11a2,2,0,0,0-2-2Z" />
        <path d="M20.45454,27.54546V37H11V27.54546h9.45454m0-2H11a2,2,0,0,0-2,2V37a2,2,0,0,0,2,2h9.45454a2,2,0,0,0,2-2V27.54546a2,2,0,0,0-2-2Z" />
        <path d="M37,27.54546V37H27.54546V27.54546H37m0-2H27.54546a2,2,0,0,0-2,2V37a2,2,0,0,0,2,2H37a2,2,0,0,0,2-2V27.54546a2,2,0,0,0-2-2Z" />
    </g>,
    'repeat'
);
const PARTITION = iconWrapper(
    <g>
        <path d="M34.5,10v4.66667h-21V10h21m0-2h-21a2,2,0,0,0-2,2v4.66667a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z" />
        <path d="M34.5,21.66666v4.66668h-21V21.66666h21m0-2h-21a2,2,0,0,0-2,2v4.66668a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V21.66666a2,2,0,0,0-2-2Z" />
        <path d="M34.5,33.33333V38h-21V33.33333h21m0-2h-21a2,2,0,0,0-2,2V38a2,2,0,0,0,2,2h21a2,2,0,0,0,2-2V33.33333a2,2,0,0,0-2-2Z" />
    </g>,
    'partition'
);
const RECTANGLE = iconWrapper(
    <g>
        <path d="M35,13V35H13V13H35m0-2H13a2,2,0,0,0-2,2V35a2,2,0,0,0,2,2H35a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2Z" />
    </g>,
    'rectangle'
);
const ELLIPSE = iconWrapper(
    <g>
        <path d="M24,12A12,12,0,1,1,12,24,12,12,0,0,1,24,12m0-2A14,14,0,1,0,38,24,14.01585,14.01585,0,0,0,24,10Z" />
    </g>,
    'ellipse'
);
const PATH = iconWrapper(
    <g>
        <path d="M31.71191,7.80273l-4.85449,4.8545-9.123,5.21289a2.89263,2.89263,0,0,0-1.32715,1.64453L11.67188,31.52832l-.22754.67188c-.44922,1.32324-.55664,1.63769-.12207,2.62011l.082.1875a3.02154,3.02154,0,0,0,1.58691,1.58789l.18848.082a2.52479,2.52479,0,0,0,1.04394.27539,5.29368,5.29368,0,0,0,1.57617-.39746l12.64063-4.94921a2.89294,2.89294,0,0,0,1.68945-1.3418l5.21289-9.12207,4.8545-4.85449ZM28.39355,29.27148a.976.976,0,0,1-.60644.44629L15.83887,34.43164l-.68262.23047c-.23279.0788-.44659.15143-.61.20569L21.65509,27.759A2,2,0,1,0,20.241,26.34491l-7.105,7.105c.05328-.16785.12488-.37878.20184-.60614l4.94434-12.63086.02734-.08105a.89962.89962,0,0,1,.418-.52539l9.23828-5.2793.18689-.18445,5.681,5.681Z" />
    </g>,
    'ellipse'
);
const AXIS = iconWrapper(
    <g>
        <polygon points="33.2,34.8 13.1,34.8 13.1,14.9 10.7,14.9 14.3,11.4 17.8,14.9 15.4,14.9 15.4,32.5 33.2,32.5 33.2,30.2 36.7,33.6 33.2,37.1 " />
    </g>,
    'axis'
);
const LEGEND = iconWrapper(
    <g>
        <path
            d="M15.6,17.9h-3.1c-0.8,0-1.5-0.7-1.5-1.5v-3.1c0-0.8,0.7-1.5,1.5-1.5h3.1c0.8,0,1.5,0.7,1.5,1.5v3.1
	C17.1,17.2,16.4,17.9,15.6,17.9z"
        />
        <rect x="20.2" y="13.7" width="16.8" height="2.3" />
        <path
            d="M15.6,27.1h-3.1c-0.8,0-1.5-0.7-1.5-1.5v-3.1c0-0.8,0.7-1.5,1.5-1.5h3.1c0.8,0,1.5,0.7,1.5,1.5v3.1
	C17.1,26.4,16.4,27.1,15.6,27.1z"
        />
        <rect x="20.2" y="22.9" width="13.8" height="2.3" />
        <path
            d="M15.6,36.2h-3.1c-0.8,0-1.5-0.7-1.5-1.5v-3.1c0-0.8,0.7-1.5,1.5-1.5h3.1c0.8,0,1.5,0.7,1.5,1.5v3.1
	C17.1,35.5,16.4,36.2,15.6,36.2z"
        />
        <rect x="20.2" y="32" width="16.8" height="2.3" />
    </g>,
    'legend'
);
const STRING = iconWrapper(
    <g>
        <path d="M24,42.5A18.5,18.5,0,1,1,42.5,24,18.52065,18.52065,0,0,1,24,42.5Zm0-36A17.5,17.5,0,1,0,41.5,24,17.52,17.52,0,0,0,24,6.5Z" />
        <path d="M19.06445,28.02246l-.998-2.77539H14.24512l-.97754,2.77539H11.54492L15.28418,17.9873h1.77734l3.73926,10.03516Zm-1.42871-4.18359-.93652-2.72071q-.10254-.27246-.28418-.86132c-.12012-.39161-.2041-.67872-.249-.86133a15.426,15.426,0,0,1-.54,1.83887l-.90235,2.60449Z" />
        <path d="M25.81152,20.3252a2.62309,2.62309,0,0,1,2.2041,1.02539,4.62455,4.62455,0,0,1,.79,2.87793,4.63839,4.63839,0,0,1-.7998,2.8955,2.91168,2.91168,0,0,1-4.4502.00293h-.10937l-.294.89551H21.94922V17.38574h1.60644V19.915c0,.1875-.00976.46484-.02734.834-.01855.36914-.03223.6045-.041.7041h.06836A2.54963,2.54963,0,0,1,25.81152,20.3252Zm-.417,1.3125a1.633,1.633,0,0,0-1.39844.57128,3.322,3.322,0,0,0-.44043,1.91016v.10938a3.5362,3.5362,0,0,0,.4375,2,1.62684,1.62684,0,0,0,1.42872.61816,1.44777,1.44777,0,0,0,1.29492-.67676,3.58876,3.58876,0,0,0,.4414-1.95508Q27.1582,21.63819,25.39453,21.6377Z" />
        <path d="M33.7207,28.15918a3.31228,3.31228,0,0,1-2.6084-1.001,4.18538,4.18538,0,0,1-.8916-2.875,4.20761,4.20761,0,0,1,.93262-2.93261,3.46237,3.46237,0,0,1,2.69727-1.02539,5.06323,5.06323,0,0,1,2.15332.44433l-.48536,1.292a4.88671,4.88671,0,0,0-1.68164-.39648q-1.96289,0-1.96191,2.60449a3.12651,3.12651,0,0,0,.48828,1.91113,1.69383,1.69383,0,0,0,1.43262.63868,4.11238,4.11238,0,0,0,2.03027-.53321V27.6875a3.14427,3.14427,0,0,1-.91992.3623A5.48692,5.48692,0,0,1,33.7207,28.15918Z" />
    </g>,
    'string',
    16
);
const DATE = iconWrapper(
    <g>
        <path d="M24,42.5A18.5,18.5,0,1,1,42.5,24,18.52065,18.52065,0,0,1,24,42.5Zm0-36A17.5,17.5,0,1,0,41.5,24,17.52,17.52,0,0,0,24,6.5Z" />
        <path d="M33.5,33.5h-20V18.58789h20Zm-18-2h16V20.58789h-16Z" />
        <path d="M33.5,20.61719h-20V13h20Zm-18-2h16V15h-16Z" />
        <rect x="17.5" y="12" width="2" height="4" />
        <rect x="27.5" y="12" width="2" height="4" />
    </g>,
    'date',
    16
);
const NUMBER = iconWrapper(
    <g>
        <path d="M24,42.5A18.5,18.5,0,1,1,42.5,24,18.52065,18.52065,0,0,1,24,42.5Zm0-36A17.5,17.5,0,1,0,41.5,24,17.52,17.52,0,0,0,24,6.5Z" />
        <rect
            x="10.65907"
            y="22.49983"
            width="19.18968"
            height="2.00034"
            transform="translate(-5.86037 40.24858) rotate(-81.91737)"
        />
        <rect
            x="17.30946"
            y="22.49983"
            width="19.18968"
            height="2.00034"
            transform="translate(-0.14504 46.83291) rotate(-81.91737)"
        />
        <rect x="14" y="26.58398" width="17.94434" height="2" />
        <rect x="15.05566" y="19.19531" width="17.94434" height="2" />
    </g>,
    'number',
    16
);
const INTEGER = iconWrapper(
    <g>
        <path d="M24,42.5A18.5,18.5,0,1,1,42.5,24,18.52065,18.52065,0,0,1,24,42.5Zm0-36A17.5,17.5,0,1,0,41.5,24,17.52,17.52,0,0,0,24,6.5Z" />
        <rect
            x="10.65907"
            y="22.49983"
            width="19.18968"
            height="2.00034"
            transform="translate(-5.86037 40.24858) rotate(-81.91737)"
        />
        <rect
            x="17.30946"
            y="22.49983"
            width="19.18968"
            height="2.00034"
            transform="translate(-0.14504 46.83291) rotate(-81.91737)"
        />
        <rect x="14" y="26.58398" width="17.94434" height="2" />
        <rect x="15.05566" y="19.19531" width="17.94434" height="2" />
    </g>,
    'integer',
    16
);
const BOOLEAN = iconWrapper(
    <g>
        <path d="M17.22852,28.02246H15.59473V19.42969H12.65527V18.02832H20.168v1.40137H17.22852Z" />
        <path d="M23.61328,17.41309h1.23047V31.31055H23.61328Z" />
        <path d="M31.03027,28.02246H29.41016V18.02832H35.0498v1.38086H31.03027v3.124h3.76661v1.3877H31.03027Z" />
        <path d="M24,42.5A18.5,18.5,0,1,1,42.5,24,18.52065,18.52065,0,0,1,24,42.5Zm0-36A17.5,17.5,0,1,0,41.5,24,17.52,17.52,0,0,0,24,6.5Z" />
    </g>,
    'boolean',
    16
);
const STAGGER_LINEAR = iconWrapper(
    <g>
        <path d="M39.8,8.2v31.5H8.2V8.2H39.8 M42,6H6v36h36V6z" />
        <rect
            x="6.3"
            y="22.9"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.9564 24.0353)"
            width="35.5"
            height="2.2"
        />
    </g>,
    'stagger-linear'
);
const STAGGER_STEPPED = iconWrapper(
    <g>
        <path d="M42,42H6V6h36V42z M8.2,39.8h31.5V8.2H8.2V39.8z" />
        <polygon points="11.5,36.5 11.5,34.3 15.6,34.3 15.6,29 20.8,29 20.8,22.8 25.4,22.8 25.4,17.9 30.4,17.9 30.4,11.5 36.5,11.5 36.5,13.8 32.7,13.8 32.7,20.2 27.7,20.2 27.7,25.1 23.1,25.1 23.1,31.3 17.9,31.3 17.9,36.5 " />
    </g>,
    'stagger-stepped'
);
const STAGGER_GROUPED = iconWrapper(
    <g>
        <path d="M42,42H6V6h36V42z M8.2,39.8h31.5V8.2H8.2V39.8z" />
        <polygon points="13.3,34.7 13.3,23.4 23.2,23.4 23.2,13.3 34.7,13.3 34.7,15.6 25.5,15.6 25.5,25.7 15.6,25.7 15.6,34.7 " />
    </g>,
    'stagger-grouped'
);
const SPEED_LINEAR = iconWrapper(
    <g>
        <path d="M42,42H6V6h36V42z M8.2,39.8h31.5V8.2H8.2V39.8z" />
        <polygon points="13.6,34.4 34.4,13.6 13.6,13.6 " />
    </g>,
    'stagger-linear'
);
const SPEED_STEPPED = iconWrapper(
    <g>
        <path d="M42,42H6V6h36V42z M8.2,39.8h31.5V8.2H8.2V39.8z" />
        <path d="M14.1,34.8H19v-5.2h5v-4.9h4.6v-6.2h5.2v-5.2H14.1V34.8z" />
    </g>,
    'stagger-stepped'
);
const SPEED_GROUPED = iconWrapper(
    <g>
        <path d="M42,42H6V6h36V42z M8.2,39.8h31.5V8.2H8.2V39.8z" />
        <path d="M14.1,34.7h9.9v-10h9.8V13.3H14.1V34.7z" />
    </g>,
    'stagger-grouped'
);
const ANIMATE = iconWrapper(
    <g>
        <path d="M30.04116,38.9662a1.96667,1.96667,0,0,1-1.40307-.58147l-3.0304-3.03238L35.89357,25.06647a1.98455,1.98455,0,0,0,0-2.80615L25.60769,11.97643l3.0304-3.0304a1.98454,1.98454,0,0,1,2.80614,0l13.3143,13.31628a1.98454,1.98454,0,0,1,0,2.80614L31.44423,38.38473A1.97259,1.97259,0,0,1,30.04116,38.9662Z" />
        <rect
            x="7.23967"
            y="12.26321"
            width="22.80041"
            height="22.80041"
            rx="1.98454"
            transform="translate(-11.27307 20.11123) rotate(-45)"
        />
    </g>,
    'animate'
);

const MATCH = iconWrapper(
    <g>
        <path
            d="M25.7,28l-8.9,8.9l-2,2C14.1,39.6,13.1,40,12,40c-2.2,0-4-1.8-4-4c0-1.1,0.4-2.1,1.2-2.8l10.9-10.9
			C19.4,22.1,18.7,22,18,22c-2.2,0-4.2,0.9-5.6,2.4l0,0l-6,6l0,0C4.9,31.8,4,33.8,4,36c0,4.4,3.6,8,8,8c2.2,0,4.2-0.9,5.6-2.4l0,0
			l6-6l0,0c1.4-1.5,2.4-3.4,2.4-5.6C26,29.3,25.9,28.6,25.7,28z M44,12c0-4.4-3.6-8-8-8c-2.2,0-4.2,0.9-5.6,2.4l0,0l-6,6l0,0
			C22.9,13.8,22,15.8,22,18c0,0.7,0.1,1.4,0.3,2l8.9-8.9l2-2C33.9,8.4,34.9,8,36,8c2.2,0,4,1.8,4,4c0,1.1-0.4,2.1-1.2,2.8L27.9,25.7
			c0.7,0.2,1.3,0.3,2.1,0.3c2.2,0,4.2-0.9,5.6-2.4l0,0l6-6l0,0C43.1,16.2,44,14.2,44,12z M14,32c0,1.1,0.9,2,2,2
			c0.6,0,1.1-0.2,1.4-0.6l16-16c0.4-0.4,0.6-0.9,0.6-1.4c0-1.1-0.9-2-2-2c-0.6,0-1.1,0.2-1.4,0.6l-4,4l-4,4l-4,4l-4,4
			C14.2,30.9,14,31.4,14,32z"
        />
    </g>,
    'match'
);

const UNMATCH = iconWrapper(
    <g>
        <path
            d="M10.5,15.4L9.8,18c-0.1,0.3,0.1,0.7,0.5,0.7l6.8,0.4c0.6,0,0.8-0.8,0.3-1l-6.1-3C10.9,14.9,10.5,15.1,10.5,15.4
	z"
        />
        <path d="M18.7,9.1l-2.6,0.7c-0.3,0.1-0.5,0.5-0.3,0.8l3,6.1c0.3,0.5,1.1,0.3,1-0.3l-0.4-6.8C19.3,9.2,19,9,18.7,9.1z" />
        <path d="M38,31.7l0.7-2.6c0.1-0.3-0.1-0.7-0.5-0.7L31.4,28c-0.6,0-0.8,0.8-0.3,1l6.1,3C37.5,32.2,37.9,32,38,31.7z" />
        <path
            d="M29.8,38l2.6-0.7c0.3-0.1,0.5-0.5,0.3-0.8l-3-6.1c-0.3-0.5-1.1-0.3-1,0.3l0.4,6.8C29.1,37.9,29.4,38.1,29.8,38z
	"
        />
        <path
            d="M25.8,27.6l-8.9,8.9l-2,2c-0.7,0.7-1.7,1.2-2.8,1.2c-2.2,0-4-1.8-4-4c0-1.1,0.4-2.1,1.2-2.8L20.1,22
	c-0.7-0.2-1.3-0.3-2.1-0.3c-2.2,0-4.2,0.9-5.6,2.4l0,0l-6,6l0,0c-1.4,1.5-2.4,3.4-2.4,5.6c0,4.4,3.6,8,8,8c2.2,0,4.2-0.9,5.6-2.4
	l0,0l6-6l0,0c1.4-1.5,2.4-3.4,2.4-5.6C26.1,29,26,28.3,25.8,27.6z M44.1,11.7c0-4.4-3.6-8-8-8c-2.2,0-4.2,0.9-5.6,2.4l0,0l-6,6l0,0
	c-1.4,1.5-2.4,3.4-2.4,5.6c0,0.7,0.1,1.4,0.3,2l8.9-8.9l2-2C34,8.1,35,7.7,36.1,7.7c2.2,0,4,1.8,4,4c0,1.1-0.4,2.1-1.2,2.8L28,25.4
	c0.7,0.2,1.3,0.3,2.1,0.3c2.2,0,4.2-0.9,5.6-2.4l0,0l6-6l0,0C43.2,15.9,44.1,13.9,44.1,11.7z"
        />
    </g>,
    'match'
);

const TREE_NODE_EXPAND_PF_SF_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,26.5H15a1.5,1.5,0,0,1,0-3h8a1.5,1.5,0,0,1,0,3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
    </g>,
    'tree-node-expand-parent-f-sibling-f-children-t'
);

const TREE_NODE_COLLAPSE_PF_SF_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,23.5H20.5V21a1.5,1.5,0,0,0-3,0v2.5H15a1.5,1.5,0,0,0,0,3h2.5V29a1.5,1.5,0,0,0,3,0V26.5H23a1.5,1.5,0,0,0,0-3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
    </g>,
    'tree-node-collapse-parent-f-sibling-f-children-t'
);

const TREE_NODE_EXPAND_PT_SF_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,26.5H15a1.5,1.5,0,0,1,0-3h8a1.5,1.5,0,0,1,0,3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
    </g>,
    'tree-node-expand-parent-t-sibling-f-children-t'
);

const TREE_NODE_COLLAPSE_PT_SF_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,23.5H20.5V21a1.5,1.5,0,0,0-3,0v2.5H15a1.5,1.5,0,0,0,0,3h2.5V29a1.5,1.5,0,0,0,3,0V26.5H23a1.5,1.5,0,0,0,0-3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
    </g>,
    'tree-node-collapse-parent-t-sibling-f-children-t'
);

const TREE_NODE_EXPAND_PT_ST_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,26.5H15a1.5,1.5,0,0,1,0-3h8a1.5,1.5,0,0,1,0,3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
        <rect fill="#999" x="18" y="40" width="2" height="2" />
        <rect fill="#999" x="18" y="44" width="2" height="2" />
    </g>,
    'tree-node-expand-parent-t-sibling-f-children-t'
);

const TREE_NODE_COLLAPSE_PT_ST_CT = iconWrapper(
    <g>
        <path d="M27.8,38.5H10.2a4.71,4.71,0,0,1-4.7-4.7V16.2a4.71,4.71,0,0,1,4.7-4.7H27.8a4.71,4.71,0,0,1,4.7,4.7V33.8A4.71,4.71,0,0,1,27.8,38.5Zm-17.6-24a1.7,1.7,0,0,0-1.7,1.7V33.8a1.7,1.7,0,0,0,1.7,1.7H27.8a1.7,1.7,0,0,0,1.7-1.7V16.2a1.7,1.7,0,0,0-1.7-1.7Z" />
        <path d="M23,23.5H20.5V21a1.5,1.5,0,0,0-3,0v2.5H15a1.5,1.5,0,0,0,0,3h2.5V29a1.5,1.5,0,0,0,3,0V26.5H23a1.5,1.5,0,0,0,0-3Z" />
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
        <rect fill="#999" x="18" y="40" width="2" height="2" />
        <rect fill="#999" x="18" y="44" width="2" height="2" />
    </g>,
    'tree-node-collapse-parent-t-sibling-f-children-t'
);

const TREE_NODE_LEAF_PT_ST = iconWrapper(
    <g>
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="30" y="24" width="2" height="2" />
        <rect fill="#999" x="26" y="24" width="2" height="2" />
        <rect fill="#999" x="22" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
        <rect fill="#999" x="18" y="12" width="2" height="2" />
        <rect fill="#999" x="18" y="16" width="2" height="2" />
        <rect fill="#999" x="18" y="20" width="2" height="2" />
        <rect fill="#999" x="18" y="28" width="2" height="2" />
        <rect fill="#999" x="18" y="32" width="2" height="2" />
        <rect fill="#999" x="18" y="36" width="2" height="2" />
        <rect fill="#999" x="18" y="40" width="2" height="2" />
        <rect fill="#999" x="18" y="44" width="2" height="2" />
    </g>,
    'tree-node-expand-parent-t-sibling-f-children-t'
);

const TREE_NODE_LEAF_PT_SF = iconWrapper(
    <g>
        <rect fill="#999" x="46" y="24" width="2" height="2" />
        <rect fill="#999" x="42" y="24" width="2" height="2" />
        <rect fill="#999" x="38" y="24" width="2" height="2" />
        <rect fill="#999" x="34" y="24" width="2" height="2" />
        <rect fill="#999" x="30" y="24" width="2" height="2" />
        <rect fill="#999" x="26" y="24" width="2" height="2" />
        <rect fill="#999" x="22" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="24" width="2" height="2" />
        <rect fill="#999" x="18" y="0" width="2" height="2" />
        <rect fill="#999" x="18" y="4" width="2" height="2" />
        <rect fill="#999" x="18" y="8" width="2" height="2" />
        <rect fill="#999" x="18" y="12" width="2" height="2" />
        <rect fill="#999" x="18" y="16" width="2" height="2" />
        <rect fill="#999" x="18" y="20" width="2" height="2" />
    </g>,
    'tree-node-collapse-parent-t-sibling-f-children-t'
);

export default {
    GROUP,
    REPEAT,
    PARTITION,
    RECTANGLE,
    ELLIPSE,
    PATH,
    AXIS,
    LEGEND,
    STRING,
    DATE,
    NUMBER,
    INTEGER,
    BOOLEAN,
    STAGGER_LINEAR,
    STAGGER_STEPPED,
    STAGGER_GROUPED,
    SPEED_LINEAR,
    SPEED_STEPPED,
    SPEED_GROUPED,
    ANIMATE,
    MATCH,
    UNMATCH,
    TREE_NODE_EXPAND_PF_SF_CT,
    TREE_NODE_COLLAPSE_PF_SF_CT,
    TREE_NODE_EXPAND_PT_SF_CT,
    TREE_NODE_COLLAPSE_PT_SF_CT,
    TREE_NODE_EXPAND_PT_ST_CT,
    TREE_NODE_COLLAPSE_PT_ST_CT,
    TREE_NODE_LEAF_PT_SF,
    TREE_NODE_LEAF_PT_ST,
};
